import React from 'react';
import { AdditionalMenu, Button } from 'seduo-ui';
const Example = (props) => (<div>
        <div className="sticky-top mb-5">
            <AdditionalMenu actionButton={<Button color="primary">Zkušební verze pro firmy zdarma</Button>} links={[
        {
            id: 'about',
            title: 'O Seduo.cz',
        },
        {
            id: 'why-is-it-worth',
            title: 'Proč se vám to vyplatí?',
        },
        {
            id: 'references',
            title: 'Reference',
        },
        {
            id: 'pricing',
            title: 'Ceník',
        },
    ]}/>
        </div>
        <div id="about" className="bg-secondary d-flex align-items-center justify-content-center" style={{
        height: 500,
    }}>
            <h1>O Seduo.cz</h1>
        </div>
        <div id="why-is-it-worth" className="bg-light d-flex align-items-center justify-content-center" style={{
        height: 500,
    }}>
            <h1>Proč se vám to vyplatí?</h1>
        </div>
        <div id="references" className="bg-secondary d-flex align-items-center justify-content-center" style={{
        height: 500,
    }}>
            <h1>Reference</h1>
        </div>
        <div id="pricing" className="bg-light d-flex align-items-center justify-content-center" style={{
        height: 500,
    }}>
            <h1>Ceník</h1>
        </div>
    </div>);
export default Example;
